/**
 * Takes in the file creation date and returns MM/DD XX:YY PM
 *
 * @param {*} birthTimeInMs
 */
export const getDateFromEpoch = () => {
  const date = new Date();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const readableHours = hours > 12 ? hours - 12 : hours;
  const readableMinutes = minutes >= 10 ? minutes : `0${minutes}`;
  return `${readableHours}:${readableMinutes} on ${
    date.getMonth() + 1
  }/${date.getDate()}`;
};

export const mapKeysToPatients = (patientKeys: any, patients: any) =>
  patientKeys.map((id: any) => {
    const {
      displayed,
      latestVisitAnalyzedImagesCount,
      analysisDate,
      examDate,
      images = {},
      firstName,
      lastName,
      name,
      patientId,
      id: videaPatientId,
      sex,
      gender,
      dataSource,
      isSearchedPatient,
      findingStats,
    } = patients[id] ?? {};
    const nameToDisplay = name ?? `${firstName || ''} ${lastName || ''}`.trim();
    const patientIdentification = patientId ?? videaPatientId;
    const numImagesToDisplay =
      latestVisitAnalyzedImagesCount ?? Object.keys(images).length;
    return {
      // we trim here here if any of the field are not defined
      name: nameToDisplay,
      numImages: numImagesToDisplay,
      analysisDate,
      examDate,
      date: getDateFromEpoch(),
      displayed,
      patientId: patientIdentification,
      sex: sex || gender,
      dataSource,
      isSearchedPatient,
      findingStats: findingStats ?? {
        numberOfCaries: null,
        rblSeverities: {
          normal: null,
          mild: null,
          moderate: null,
          severe: null,
        },
      },
    };
  });

// blocks for x ms
export function sleep(ms: any) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
